/* eslint-disable react/no-this-in-sfc */

import { getClosest } from '../helpers/DOMManipulation';

const DEFAULT_DURATION = 3000;

const Toast = {
  /**
   * Create toast
   * @param {String} msg
   * @param {Number} duration
   * @param {String} type
   * @return {void}
   */
  create(msg, duration, type = 'success') {
    // Create toast element
    this.toastElement = this.createToast(msg, duration, type);

    // Add it to the DOM
    document.body.appendChild(this.toastElement);

    // Fade the toast in (it's hidden by default)
    setTimeout(() => {
      this.toastElement.className = this.toastElement.className.replace('toast--fade-out', '');
    }, 30);

    // If a duration is defined we delete the toast after the duration ms
    if (duration > 0) {
      setTimeout(() => {
        if (!this.toastElement) {
          return;
        }

        this.deleteToast();
      }, duration);
    }
  },

  /**
   * Create toast DOMNode
   * @param {String} text Text for the toast element
   * @param {Number} duration
   * @param {String} type Type used for the style of the toaster
   * @return {HTMLDivElement}
   */
  createToast(text, duration, type) {
    const msg = document.createElement('div');
    msg.innerHTML = text;
    msg.className = `toast toast--${type} toast--fade-out`;
    msg.setAttribute('aria-live', 'polite');

    const btn = document.createElement('button');
    btn.className = 'toast__close btn--reset';
    btn.innerHTML = '<i class="fas fa-times" aria-hidden="true"></i>';
    btn.title = 'Close';
    msg.appendChild(btn);

    return msg;
  },

  /**
   * Delete toast element
   * @return {void}
   */
  deleteToast() {
    this.toastElement.className += ' toast--fade-out';

    setTimeout(() => {
      if (!this.toastElement.parentNode) {
        return;
      }
      this.toastElement.parentNode.removeChild(this.toastElement);
      this.deleteCallback();
    }, 300);
  },
};

const toaster = {
  toastsStack: [],

  /**
   * Show initial toast defined on the toasts global variable
   * @return {void}
   */
  initialize() {
    if (typeof window.toasts === 'undefined') {
      return;
    }

    // Loop through all defined toast and show them
    window.toasts.forEach((toast) => {
      this.show(toast.message, toast.duration ? toast.duration : DEFAULT_DURATION, toast.type ? toast.type : 'success');
    });

    document.body.addEventListener('click', (e) => {
      const toast = getClosest(e.target, '.toast');
      if (!toast) {
        return true;
      }

      const toastObj = this.findToastInStack(toast);

      if (toastObj === null) {
        return true;
      }

      toastObj.deleteToast();

      return false;
    });
  },

  /**
   * Show the toast
   * @param args
   * @return {void}
   */
  show(...args) {
    const toast = { ...Toast };
    toast.create(...args);
    toast.deleteCallback = () => {
      const index = this.findToastIndexInStack(toast.toastElement);
      this.toastsStack.splice(index, 1);
    };

    this.toastsStack.push(toast);
  },

  /**
   * Get the index of a toast item in the toasts stack
   * @param {HTMLElement} toast
   * @return {Number}
   */
  findToastIndexInStack(toast) {
    return this.toastsStack.reduce((acc, toastObj, i) => {
      if (acc) {
        return acc;
      }
      return toastObj.toastElement === toast ? i : null;
    }, null);
  },

  /**
   * Find toast element in stack
   * @param {HTMLElement} toast
   * @return {Object}
   */
  findToastInStack(toast) {
    const index = this.findToastIndexInStack(toast);

    if (index !== null) {
      return this.toastsStack[index];
    }

    return null;
  },
};

export default toaster;
